import {Component, OnInit, Input, OnDestroy} from '@angular/core';
import {ModalController} from '@ionic/angular';
import {Option} from '../../models/option';
import {UiUtils} from '../../util/ui-utils';
import {TranslateService} from '@ngx-translate/core';
import { takeWhile, map } from 'rxjs/operators';
import {OrderItem} from "../../models/order-item";
import {OptionGroupService} from "../../services/option-group.service";

interface OptionCheckbox {
  option: Option;
  isChecked: boolean;
  isEnabled: boolean;
}

@Component({
  selector: 'app-select-option',
  templateUrl: './select-option.component.html',
  styleUrls: ['./select-option.component.scss'],
})
export class SelectOptionComponent implements OnInit, OnDestroy {

  @Input() orderItem: OrderItem;
  @Input() currentOrderItem = 0;
  @Input() showPagination = true;

  mainCheckboxes: OptionCheckbox[][] = [];
  extraCheckboxes: OptionCheckbox[][] = [];

  private isComponentActive = true;

  private lastMainCheckboxChecked: OptionCheckbox;
  private skipToggleEvent = false;

  constructor(private modalController: ModalController,
              private optionService: OptionGroupService,
              private uiUtils: UiUtils,
              private translateService: TranslateService) {
  }

  ngOnInit() {
    for (let i = 0; i < this.orderItem.quantity; i++) {
      this.mainCheckboxes.push([]);
      this.extraCheckboxes.push([]);
    }

    this.fetchOptions();
    this.modalController.getTop().then((ionModal: HTMLIonModalElement) => ionModal.cssClass = 'option-select-modal');
  }

  private fetchOptions() {
    this.optionService.observeOptionGroups()
        .pipe(
            takeWhile(() => this.isComponentActive),
            map((options) => options.filter((option) => {
              return this.orderItem.optionsSelected.find((itemOption) => itemOption.name === option.name);
            })),
            map(options => options.sort((a, b) => {
              if ( a.name > b.name ) { return  1; }
              if ( a.name < b.name ) { return -1; }
              return 0;
            })),
        )
        .subscribe((options) => {
          if (options.length === 0) { this.modalController.dismiss(); }

          // options.forEach((option) => {
          //   const itemOption = this.orderItem.options.find((iOption) => iOption.optionId === option.uid);
          //   if (itemOption.isMain ) { this.addOnMainCheckbox ({...option}); }
          //   if (itemOption.isExtra) { this.addOnExtraCheckbox({...option}); }
          // });
        });
  }

  nextOrder() {
    this.currentOrderItem = Math.min(this.currentOrderItem + 1, this.orderItem.quantity - 1);
  }

  prevOrder() {
    this.currentOrderItem = Math.max(this.currentOrderItem - 1, 0);
  }

  dismissSelfWithData() {
    // const amountMainOptionsRequired = this.orderItem.amountMainOptionsRequired;

    for (let index = 0; index < this.mainCheckboxes.length; index++) {
      const page = this.mainCheckboxes[index];
      const amountMainOptionsSelected = page.filter((checkbox) => checkbox.isChecked).length;

      // if (amountMainOptionsSelected < amountMainOptionsRequired) {
      //   this.translateService.instant('component.selectOption.optionsRequired');
      //   this.uiUtils.showConfirmAlert(
      //       this.translateService.instant('component.selectOption.optionsRequired'),
      //       // tslint:disable-next-line:max-line-length
      //       this.translateService.instant('component.selectOption.chooseAtLeast')+` ${amountMainOptionsRequired} `+this.translateService.instant('component.selectOption.baseOptions')+'.',
      //       this.translateService.instant('component.selectOption.accept')
      //   );
      //   this.currentOrderItem = index;
      //   return;
      // }
    }

    this.modalController.dismiss({ 'optionsSelected': this.allOptionsSelected() });
  }

  onMainCheckboxToogle(mainCheckbox: OptionCheckbox) {
    this.disableDuplicatedExtraOption(mainCheckbox);
    if (this.skipToggleEvent) { return this.skipToggleEvent = false; } // TODO: CHECK THIS

    const amountMainOptionsSelected = this.mainCheckboxes[this.currentOrderItem].filter((mainOption) => mainOption.isChecked).length;
    // const amountMainOptionsRequired = this.orderItem.amountMainOptionsRequired;

    // if (amountMainOptionsSelected > amountMainOptionsRequired) {
    //   this.lastMainCheckboxChecked.isChecked = false;
    //   this.skipToggleEvent = true;
    // }
    this.lastMainCheckboxChecked = mainCheckbox;
  }

  private addOnMainCheckbox(option: Option) {
    this.mainCheckboxes.forEach((value, index) => {
      // const orderOption = this.orderItem.optionsSelected[index].find((value2) => value2.uid === option.uid);
      // option.price = 0;
      // value.push({option: option, isChecked: orderOption ? orderOption.isMain : false, isEnabled: true});
    });
  }

  private addOnExtraCheckbox(option: Option) {
    this.extraCheckboxes.forEach((value, index) => {
      // const orderOption = this.orderItem.optionsSelected[index].slice().reverse().find((value) => value.uid === option.uid);
      // value.push({option: option, isChecked: orderOption ? orderOption.isExtra : false, isEnabled: true});
    });
  }

  private disableDuplicatedExtraOption(mainOption: OptionCheckbox) {
    // const extraOption = this.extraCheckboxes[this.currentOrderItem].find(o => o.option.uid === mainOption.option.uid);
    // if (extraOption) {
    //   extraOption.isEnabled = !mainOption.isChecked;
    //   extraOption.isChecked = false;
    // }
  }

  private allOptionsSelected(): Option[][] {
    const optionsSelected: Option[][] = [];

    for (let i = 0; i < this.orderItem.quantity; i++) {

      // const main = this.mainCheckboxes[i].filter((value) => value.isChecked)
      //     .map((checkbox) => {
      //       checkbox.option.isMain = true; checkbox.option.isExtra = false;
      //       return checkbox.option;
      //     });
      //
      // const extra = this.extraCheckboxes[i].filter((value) => value.isChecked)
      //     .map((checkbox) => {
      //       checkbox.option.isMain = false; checkbox.option.isExtra = true;
      //       return checkbox.option;
      //     });
      //
      // optionsSelected.push([...main, ...extra]);
    }

    return optionsSelected;
  }

  ngOnDestroy() {
    this.isComponentActive = false;
  }
}
